const React = require('react');
const withState = require('../../../../utils/withState');
const Caption = require('../../../dumb/Caption/C');

const {paramStore} = require('../../../../stores');
const formatNumFiat = require('../../../../utils/formatNumFiat');

const DashboardBlockTimeFilter = require('./components/DashboardBlockTimeFilter');
const DashboardStats = require('./components/DashboardStats');
const DashboardGraph = require('./components/DashboardGraph');
const {apiV2ReferralTrxCountGet} = require("../../../../api/referral/dashboard");

const trxCount$ = paramStore('trxCount', 'all');
const trxValue$ = paramStore('trxValue', 'all');
const chartValue$ = paramStore('chartValue', 'sixMonths');

module.exports = withState(() => {
  return (state) => {
    const numberOfTrx = '123';
    const valueOfTrxCount = '12000';
    const valueOfTrxCoin = 'EUR';

    const retailersAdded = 42;
    const retailersActive = 16;

    const acceptance = 'https://console.lunu.io/signup?refer=partner&refCode+CFP&refCode+CFP&refCode+CFP&refCode+CFP...';
    const onRamp = 'https://console.lunu.io/signup?refer=partner&refCode+CFP&refCode+CFP&refCode+CFP&refCode+CFP...';

    return (
      <div>
        <div className="h48 layoutRow aiC">
          <Caption>Dashboard</Caption>
        </div>
        <div className="layoutRow fxwWrap mh-12 (w50%|mt24|ph12)>1">
          <div>
            <DashboardBlockTimeFilter
              title="number of Transactions"
              propValue="tx_count"
              request={apiV2ReferralTrxCountGet}
              value={numberOfTrx}
              timePeriodEmitter={trxCount$}
            />
          </div>
          <div>
            <DashboardBlockTimeFilter
              title="value of Transactions"
              request={apiV2ReferralTrxCountGet}
              handleValue={({total_amount}) => `${formatNumFiat(total_amount)} ${valueOfTrxCoin}`}
              timePeriodEmitter={trxValue$}
            />
          </div>
          <DashboardStats />
        </div>
        {/*<div className="mt39">*/}
        {/*  <DashboardGraph*/}
        {/*    timePeriodEmitter={chartValue$}*/}
        {/*  />*/}
        {/*</div>*/}
      </div>
    );
  };
});
